import { render } from "./MidnightSplitRow.vue?vue&type=template&id=123f993a&ts=true"
import script from "./MidnightSplitRow.ts?vue&type=script&lang=ts&external"
export * from "./MidnightSplitRow.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__